import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleMarkResultAsViewed } from "../../api-clients/activitiesClient";

function useMarkActivityViewedMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (referenceId: string) => handleMarkResultAsViewed(referenceId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.ACTIVITY.BASE],
      });
    },
  });
}

export default useMarkActivityViewedMutation;
